import { render, staticRenderFns } from "./todo-header.vue?vue&type=template&id=7e747a7b&"
import script from "./todo-header.vue?vue&type=script&lang=ts&"
export * from "./todo-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports